<script context="module">
  let waiting = Promise.resolve();
</script>

<script>
  import { createEventDispatcher } from "svelte";
  import { fade, fly } from "svelte/transition";
  import Label from "./Label.svelte";

  export let text = undefined;
  export let ok = false;
  export let error = false;
  export { className as class };
  export let timeout = 5000;

  const dispatch = createEventDispatcher();
  const NOOP = () => {};

  let className = "";
  let snackbar;
  let opened = false;

  let closeResolve;
  let closePromise = new Promise((resolve) => (closeResolve = resolve));

  const close = async () => {
    opened = false;
    closeResolve();
    closePromise = new Promise((resolve) => (closeResolve = resolve));
  };

  export function open(...args) {
    waiting = waiting.then(() => {
      opened = true;
      setTimeout(() => {
        close();
      }, timeout);
      return closePromise;
    });
    return closePromise;
  }
</script>

{#if opened}
  <article
    bind:this={snackbar}
    class:opened
    class:error
    class:ok
    class=" snackbar {className}"
    in:fly={{ y: -200, duration: 1000 }}
    out:fade>
    <slot>
      {#if text}
        <Label {text} noshrink />
      {/if}
    </slot>
  </article>
{/if}

<style>
  article {
    z-index: 999;
    display: none;
    position: absolute;
    top: 0;
    left: 50%;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background-color: var(--primary-x-light-gray-color);
    transform: translate(-50%, 0);
    padding: 1em;
  }

  article.opened {
    display: block;
  }

  article.ok {
    background-color: var(--primary-light-color);
    color: var(--on-error-color);
  }

  article.error {
    background-color: var(--error-color);
    color: var(--on-error-color);
  }
</style>
